import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/",
    redirect: "/home"
  },
  {
    path: "/home",
    name: "Home",
    component: () =>
      import(/* webpackChunkName: "home" */ "@/views/Home/Home.vue")
  },
  {
    path: "/questionnaire/:code/:role",
    name: "Questionnaire",
    component: () =>
      import(/* webpackChunkName: "home" */ "@/views/Questionnaire/Questionnaire.vue")
  },

  //{
  //  path: "/career",
  //  name: "Join us",
  //  component: () =>
  //    import(/* webpackChunkName: "career" */ "@/views/Career/Career.vue")
  //},
  //{
  //  path: "/contact",
  //  name: "Contact",
  //  component: () =>
  //    import(/* webpackChunkName: "contact" */ "@/views/Contact/Contact.vue")
  //},
  //{
  //  path: "/about",
  //  name: "About",
  //  component: () =>
  //    import(/* webpackChunkName: "about" */ "@/views/About/About.vue")
  //},
  {
    path: "/privacy-policy",
    name: "Privacy Policy",
    component: () =>
      import(
        /* webpackChunkName: "privacy-policy" */ "@/views/PrivacyPolicy/PrivacyPolicy.vue"
      )
  },
  {
    path: "/terms-conditions",
    name: "Terms and Conditions",
    component: () =>
      import(
        /* webpackChunkName: "privacy-policy" */ "@/views/Terms/TermsAndConditions.vue"
      )
  }
];


const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash
      }   
    }
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
 
});

export default router;
